import { t } from "i18next";

import "./editors.css";

/**
 * A saved value, shown the way the rest of the app shows one.
 *
 * Every other screen that opens a record to read prints it as text — a quiet
 * label with the value under it and no box around either. These editors were
 * built as one form used in two modes, so view mode was the same fields with
 * `disabled` on them: a page of empty-looking boxes, dropdown carets and
 * segmented strips, all of them saying "here is something to fill in" about a
 * record nobody is filling in. What they carry is read out here instead, and
 * the controls only appear when there is something to do with them.
 *
 * The values are the app's, not this feature's: `--listing-page-user-title` for
 * the label and 14/600 for the value are what `form-heading` and `form-mt-10`
 * are elsewhere. They are restated in `editors.css` rather than borrowed,
 * because those two classes live in the report screens' stylesheet and would
 * only be loaded here by accident.
 */
export function ReadField({ label, value, wide = false }) {
  const blank = value === null || value === undefined || value === "";
  return (
    <div className={`hpv2-read-field ${wide ? "hpv2-read-field-wide" : ""}`.trim()}>
      {label && <div className="hpv2-read-label">{label}</div>}
      <div className={`hpv2-read-value ${blank ? "is-blank" : ""}`.trim()}>{blank ? "—" : value}</div>
    </div>
  );
}

/** A switch read back. The app writes a saved boolean as Yes or No. */
export const readYesNo = (on) => t(on ? "confirm-message.yes" : "confirm-message.no");

/** The label of the option that is set, for a strip or a dropdown. */
export const readOption = (options, value) =>
  options.find((option) => option.value === value)?.label ?? null;
